module.exports = __webpack_public_path__ + "img/facturacionIcon.6365cbd9.svg";